import { APP_CLEAR_CURRENT_USER } from '../actions/app.actions'
import * as Actions from '../actions/clients_mysql.actions'

const initialState = []

export default (state = initialState, action) => {
  switch (action.type) {
    case Actions.CLEAN_CLIENT_MYSQL:
      return []
    case Actions.ADD_CLIENT_MYSQL:
       return [...state, action.client]
    case APP_CLEAR_CURRENT_USER:
      return initialState
    default:
      return state
  }
}